import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class JEEDetails extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-60 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
					<p>“MIET - The Key to Your JEE Success in Chennai”</p><br/>
				  <h1 style={{fontSize: '30px'}}>Best JEE Coaching in Kodambakkam, Chennai</h1><br/>
				  
				  <p>Are you fond of building and designing, structuring, and implementing? Then JEE (Joint Entrance Examination) is your path. Constituting two levels of examinations- JEE Mains and JEE Advanced, the joint assessment exam is for all undergraduate courses in IITs (Indian Institute of Technology), NITs (National Institute of Technology), IIITs (Indian Institute of Information Technology) and a few GFTIs (Government Funded Technical Institutes). A few other colleges including IISER (Indian Institutes of Science Education and Research), IIPT (Indian Institute of Petroleum and Energy), IISc (Indian Institute of Science), or IIST (Indian Institute of Space Science and Technology) may take JEE Advanced scores and a basis of admission. JEE Mains is an eligibility test for JEE Advanced, compulsory to take if the applicant aspires for admission in programs offered by the IITs.</p>
                    </ScrollAnimation>	
                    <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							<p>The exam is an opening to courses in engineering, planning, and architecture at the above institutes. At MIET, the <b> best JEE coaching centre Chennai,</b> we provide the best learning experience for JEE aspirants through expert faculty, comprehensive study material, and regular mock tests. Join us to secure your future in engineering.</p><br/>
							<h1 style={{fontSize: '30px'}}>MIET - JEE best coaching centre in Chennai</h1><br/>
							<p>Unlock your full potential with MIET's top-notch <b> JEE coaching in Chennai.</b> Our dedicated team of experts are here to maximize your scores, and pave the way to your dream career.</p>
							
                           
                            
							<ul>
                                <li><b>Engineering:</b> The B.E. (Bachelor of Engineering) or B. Tech (Bachelor of Technology) are professional undergraduate engineering degrees offering specialisations to enter different industries. While B.E is more theoretical in approach, B. Tech focuses more on practical implementation.</li>
                                <li><b>Planning:</b> The B. Plan (Bachelors in Planning) is a professional course to train aspirants in designing, engineering, managing and overcoming challenges related to urban human settlements. </li>
                                <li><b>Architecture:</b> The B. Arch (Bachelors in Architecture) is a blend of theoretical and practical knowledge to learn the art of planning, designing and constructing physical architectural structures.</li>
                            </ul>
						</blockquote>
					</div>
					</ScrollAnimation>
                 
                  <p>It is conducted once a year with the <b>eligibility criteria</b> as follows:</p>
                  <p><b>Qualifications: </b> Appearing in or have passed 12th (or equivalent) from a recognised board.</p>
                  <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							<p><b>Subjects:</b> Applicants should have passed:</p>
							<ul>
                                <li>Maths, Physics and Chemistry/Biology/Biotechnology/Technical Vocational Subject for B.E./B.Tech [Engineering]</li>
                                <li>Maths, Physics and Chemistry for B. Arch [Architecture] </li>
                                <li>Maths for B. Plan (Planning)</li>
                            </ul>
						</blockquote>
					</div>
					</ScrollAnimation>
                    <ScrollAnimation animateIn="fadeInRight">
                        <p><b>Attempts:</b> 3 consecutive attempts. The exam is conducted in two attempts (June & July)</p>
                        <p><b>Eligibility Marks (to appear for JEE):</b> Aggregate for PCB: 50% (General), 45% (PWD), 40% (OBC/SC/ST)</p>
                        <p><b>Mode of Classes:</b> Offline, Online & Hybrid</p>
                        <p><b>Batches:</b> Regular, Evening & Weekend available.</p>

						<br/><br/>
						<p>With a team of experienced and passionate educators, MIET is one of the top <b> JEE coaching centers in Chennai.</b> Their proven methodology and personalized approach have helped numerous students achieve their dreams of getting into top engineering colleges.</p>
					</ScrollAnimation>
                  <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
                        <h5 className="mb-0 mt-2">How does MIET, the best JEE coaching centre in Chennai help you crack JEE?</h5><br/>
							<p>Cracking JEE without proper guidance and strategy can be a challenge. MIET, the <b> best coaching center for JEE in Chennai</b> helps you take that challenge and win it.</p>
							
							<ul className="single-list-wrap">
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Experienced and encouraging faculties.
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Customised study plan.
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Constant revision and mock test sessions.
								</li>
								<li className="single-list-inner style-check">
									<i className="fa fa-check" /> Strong basics for all formulas.
								</li>
                                <li className="single-list-inner style-check">
									<i className="fa fa-check" /> Strategising paper solving to maximise time usage.
								</li>
                                {/* <b>Not just theory, we help you gain practical skills too!</b> */}
							</ul>
                            
						</blockquote>
					</div>
					</ScrollAnimation>
                    <p>We, the best <b> JEE training institute in Chennai</b> have completed one successful batch of aspiring JEE and NEET Candidates and are ready to welcome another one! Join us NOW and give your dreams the wings they need.</p><br/>
					<p>Worried about the high <b> JEE Coaching Fees in Chennai?</b> Affordable JEE Coaching in Chennai at MIET. We offer high-quality coaching at a fraction of the cost, without compromising on results. Contact us today to learn more and start your JEE preparation journey!</p><br/>
					<ScrollAnimation animateIn="fadeInRight">
						<div className='blog-details-page-content'>
						<blockquote>
							<h5 className="mb-0 mt-2">Application Form:</h5><br/>
							<Link to="/online-payment"><button className="btn btn-base" style={{color:'white',fontWeight:'700'}}>Visit</button></Link>
						</blockquote>
						</div>
					</ScrollAnimation>
				  </div>
		      </div>
			  <Sidebar courseRestriction="JEE"/>
		    </div>
		  </div>
		</div>

        }
}

export default JEEDetails